module.exports = __webpack_public_path__ + "img/FAR3_600x516.3f711a01.jpg";